import { Fragment } from "react";
import { Mui } from "@osu/react-ui";
import ReportingOpen from "./ReportingOpen";
import Deadlines from "./Deadlines";
import Compliance from "./Compliance";
import { useGetSessionInfoQuery } from "../../services/submissionPeriod/api";
import { SESSION_KINDS } from "../../util/constants";
import { useGetSystemMessageQuery } from "../../services/shared/api";
import DashboardAlert from "./Alert";

const fifteenMinutes = 15 * 60 * 1000

function Dashboard() {
  const { isLoading } = useGetSessionInfoQuery({ type: SESSION_KINDS.FGC });
  const { data } = useGetSystemMessageQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: fifteenMinutes
  })
  const { message = '' } = data || {}
  
  return (
    <Fragment>
      <DashboardAlert sx={{ mb: 2 }} message={message} />
      <Mui.Grid container spacing={4}>
        <Mui.Grid size={{ xs: 12, md: 6 }}>
          <ReportingOpen loading={isLoading} />
        </Mui.Grid>
        <Mui.Grid size={{ xs: 12, md: 6 }}>
          <Deadlines loading={isLoading} />
        </Mui.Grid>
        <Mui.Grid sx={{ mb: 5 }} size={{ xs: 12 }}>
          <Compliance />
        </Mui.Grid>
      </Mui.Grid>
    </Fragment>
  );
}

export default Dashboard;
